(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
const $ = window.jQuery

$(() => {
  let oldHeight = -1

  const onResize = function () {
    const footer = $('footer.footer')
    const footerHeight = footer.innerHeight()
    if (oldHeight === footerHeight) {
      return // skip if the height has not changed since last time
    }

    $('.sticky-footer-page-content-wrapper').css({ marginBottom: +(footerHeight * -1) + 'px' })
    $('#sticky-footer-styling').remove()

    $(`<style id="sticky-footer-styling">.sticky-footer-page-content-wrapper::after{height:${footerHeight}px !important}</style>`).appendTo('head')
  }

  $(window).resize(onResize)
  onResize()
})

}).call(this,require("rH1JPG"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/_sticky-footer.js","/")